import { TablePaginationConfig } from 'antd'
import { PagingParams } from 'Modules'
import { useState } from 'react'

import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from 'constants/pagination'

const useSearchParams = <T extends PagingParams>(defaultParams?: T) => {
  const [searchParams, setSearchParams] = useState<T>({
    page: DEFAULT_PAGE_INDEX,
    limit: DEFAULT_PAGE_SIZE,
    ...(defaultParams || {}),
  } as unknown as T)

  const onSearch = (input?: Partial<T>) => {
    setSearchParams((pre: T) => {
      return {
        ...pre,
        ...(input || {}),
        page: DEFAULT_PAGE_INDEX,
        limit: DEFAULT_PAGE_SIZE,
      }
    })
  }

  const initPagination = (total: number) => {
    return {
      total,
      current: searchParams.page,
      pageSize: searchParams.limit,
    }
  }

  const onChangePagination = (pagination: TablePaginationConfig) => {
    const { current: newPage, pageSize: newPageSize } = pagination
    setSearchParams(() => {
      return {
        ...searchParams,
        page: newPage,
        limit: newPageSize,
      }
    })
  }

  return {
    searchParams,
    setSearchParams,
    initPagination,
    onSearch,
    onChangePagination,
  }
}

export default useSearchParams
